module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.1561b424.woff2";